import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {ProductSaleAuditReportModel} from "./product-sale-audit-report.model";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-product-sale-audit-report",
    templateUrl: "./product-sale-audit-report.component.html",
    providers: [provideReportModel(ProductSaleAuditReportModel)]
})
export class ProductSaleAuditReportComponent extends AbstractReportPage {
    constructor(public model: ProductSaleAuditReportModel) {
        super();
    }
}
